import { render } from "./Registrar.vue?vue&type=template&id=53445512&scoped=true"
import script from "./Registrar.vue?vue&type=script&lang=js"
export * from "./Registrar.vue?vue&type=script&lang=js"

import "./Registrar.vue?vue&type=style&index=0&id=53445512&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53445512"]])

export default __exports__